var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.400391,
    height: 16.799805,
    viewBox: "0 0 15.4004 16.7998",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M6.16 0C5.94 -0.01 5.76 0.06 5.61 0.21C5.45 0.35 5.38 0.52 5.38 0.73L0.77 0.73C0.56 0.72 0.38 0.79 0.22 0.94C0.07 1.08 0 1.25 0 1.46C0 1.66 0.07 1.83 0.22 1.98C0.38 2.12 0.56 2.19 0.77 2.19L14.62 2.19C14.83 2.19 15.01 2.12 15.17 1.98C15.32 1.83 15.4 1.66 15.4 1.46C15.4 1.25 15.32 1.08 15.17 0.94C15.01 0.79 14.83 0.72 14.62 0.73L10.01 0.73C10.01 0.52 9.94 0.35 9.78 0.21C9.63 0.06 9.45 -0.01 9.23 0L6.16 0ZM0.77 3.65L0.77 15.33C0.77 16.14 1.46 16.79 2.31 16.79L13.08 16.79C13.93 16.79 14.62 16.14 14.62 15.33L14.62 3.65L0.77 3.65Z",
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDeleteIcon);
export default __webpack_public_path__ + "static/media/BlackDeleteIcon.dbadd7f3cc523550b73abf74e2b3eb2d.svg";
export { ForwardRef as ReactComponent };